import { HttpClient, HttpContextToken, HttpHandler } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurableHttpClient } from '@corelabs/angular/core';
import { SKIP_ERROR_MESSAGE } from '../http-context';

// Augments the original module so call sites see the fluent methods without casting (TS#13897).
declare module '@angular/common/http' {
    export interface HttpClient {
        /** Skips the error-message toast for this request. */
        skipErrorMessageInterceptor(): HttpClient;
    }
}

/* Extends the corelabs client so the app method chains with the library's skip*()/add*() in both directions. */
class AppHttpClient extends ConfigurableHttpClient {
    override skipErrorMessageInterceptor(): HttpClient {
        return this.with(SKIP_ERROR_MESSAGE);
    }

    protected override clone(tokens: ReadonlySet<HttpContextToken<boolean>>): AppHttpClient {
        return new AppHttpClient(this.httpHandler, tokens);
    }
}

/* Swapped in for HttpClient in app.config.ts, after provideCore() so it wins the token. */
@Injectable()
export class HttpService extends AppHttpClient {
    constructor() {
        super(inject(HttpHandler), new Set());
    }
}
